import React, { useState, useEffect } from "react";
import instance from "../../api/api";
import InputCreate from "../../features/InputCreate";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
// import { useSelector, useDispatch } from "react-redux";
// import { toogleVerifInfo } from "../../store/slice/PrintSlice";
import * as dayjs from "dayjs";
import { useParams, useNavigate } from "react-router-dom";
import { LoadingSpinner, Header } from "../../shared/compoments";
// import { Help } from "../../utils";
import dataMoyensPayments from "./data";
dayjs().format();

const VerificationFacture = ({
  doPaiement,
  isLoading,
  setVerifInformation,
}) => {
  return (
    <div className="w-50 bg-light p-3">
      <h5 className="text-center p-3">Voulez-vous enregistrer ce paiement</h5>
      <div className="d-flex justify-content-center gap-4">
        <button
          className="btn bg-success text-light"
          onClick={() => {
            doPaiement();
          }}>
          {isLoading ? "Chargement..." : "Confirmer"}
        </button>
        <button
          className="btn bg-danger text-light"
          onClick={() => {
            setVerifInformation(false);
          }}>
          Retour
        </button>
      </div>
    </div>
  );
};

function CreatePaiements() {
  const MySwal = withReactContent(Swal);
  //   function handleDiff(date_fin, date_debut) {
  //     return dayjs(date_fin).diff(dayjs(date_debut), "month");
  //   }
  // const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState({
    amount_paid: "",
    channel: "",
    facture_id: id,
    monai_rendu: null,
    operateur: "",
  });

  const [verifInformation, setVerifInformation] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingRoute, setIsLoadingRoute] = useState(true);
  const [allFactures, setAllFactures] = useState(null);
  //   const [prixPropriete, setPrixPropriete] = useState(0);
  //   const [getReference, setGetReference] = useState(null);
  const doPaiement = async () => {
    console.log("RESUME DATA", data);
    setIsLoading(true);
    try {
      const response = await instance.post("payments", data);

      console.log(response);
      if (response.data.status === false) {
        let msgError = [];
        for (const property in response.data.message) {
          msgError = [...msgError, response.data.message[property]];
        }
        MySwal.fire({
          title: msgError,
          icon: "info",
          showConfirmButton: true,
        });
        setIsLoading(false);
      } else {
        setIsLoading(false);
        setData({
          amount_paid: "",
          channel: "",
          facture_id: "",
          monai_rendu: "",
          operateur: " ",
        });
        MySwal.fire({
          title: "Enregistrement reussi.",
          icon: "success",
          showConfirmButton: false,
          timer: 1500,
        });
        setVerifInformation(false);
        navigate(-1);
      }
    } catch (error) {
      console.log(error);
      // let msgError = [];
      // for (const property in error.response.data.message) {
      //   msgError = [...msgError, error.response.data.message[property]];
      // }
      MySwal.fire({
        title: error.response.data.errors,
        icon: "info",
        showConfirmButton: true,
      });
      setIsLoading(false);
    }
  };
  useEffect(() => {
    const getListFactures = async () => {
      try {
        const response = await instance.get("factures");
        console.log("getListFactures", response);
        setAllFactures(
          response.data.data.find((item) => Number(item.id) === Number(id))
        );
        setIsLoadingRoute(false);
      } catch (error) {
        console.log(error);
      }
    };
    getListFactures();
  }, []);
  if (isLoadingRoute) return <LoadingSpinner />;
  return (
    <>
      <Header
        libelle={`Paiement de la facture : ${allFactures.reference}`}
        isReturn
      />

      <div className="create-user">
        {verifInformation && (
          <div
            style={{
              position: "fixed",
              top: "0",
              left: "0",
              width: "100%",
              height: "100%",
              background: "#00000069",
              display: "flex",
              justifyContent: "center",
              placeItems: "center",
              zIndex: "99",
            }}>
            <VerificationFacture
              isLoading={isLoading}
              doPaiement={doPaiement}
              setVerifInformation={setVerifInformation}
            />
          </div>
        )}
        <form>
          <label htmlFor="duree">Séléctionne le moyen de paiement</label>
          <select
            for="duree"
            className="w-100 p-3"
            name=""
            id=""
            defaultValue={data.channel}
            onChange={(e) => setData({ ...data, channel: e.target.value })}>
            <option value="">Séléctionne un moyen de paiement</option>
            {dataMoyensPayments.map(
              (item, index) =>
                item.isVisible && (
                  <option key={index} value={item.libelle}>
                    {item.libelle}
                  </option>
                )
            )}
          </select>
          {data.channel === "paiement mobile" && (
            <div>
              <label htmlFor="operateur">Opérateur</label>
              <select
                htmlFor="operateur"
                className="w-100 p-3"
                name="operateur"
                id="operateur"
                defaultValue={data.operateur}
                onChange={(e) =>
                  setData({ ...data, operateur: e.target.value })
                }>
                <option value="" disabled>
                  Séléctionne un opérateur
                </option>
                <option value="Orange money">Orange</option>
                <option value="Moov money">Moov</option>
                <option value="MTN money">MTN</option>
                <option value="Wave">Wave</option>
              </select>
            </div>
          )}

          <InputCreate
            label="Montant (Fcfa)"
            typeInput="number"
            nameInput="Montant"
            active={true}
            getValue={(e) => {
              setData({ ...data, amount_paid: e.target.value });
            }}
            dataValue={data.amount_paid}
          />

          <span className="my-3 text-danger">
            Montant a payé:{" "}
            {!allFactures.total_restant
              ? Number(allFactures.cost)
              : Number(allFactures.total_restant)}{" "}
            Fcfa
          </span>
          <InputCreate
            label="Montant rendu"
            typeInput="number"
            nameInput="Montant rendu"
            active={true}
            getValue={(e) => {
              setData({ ...data, monai_rendu: e.target.value });
            }}
            dataValue={data.monai_rendu}
          />

          <div>
            <button
              className="btn bg-dark text-light mt-4"
              onClick={(e) => {
                e.preventDefault();
                if (data.amount_paid && data.channel && data.facture_id) {
                  setVerifInformation(true);
                } else {
                  window.alert("Veuillez renseigner tous les champs");
                }
              }}>
              Enregistrer
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default CreatePaiements;
